/*
 * PZ cart upsell — one-tap add from the cart drawer / cart page.
 *
 * The cards are rendered by snippets/pz-cart-upsell.liquid inside the drawer,
 * so every cart change re-renders them through Dawn's section rendering and
 * an item that just landed in the cart drops out of the list by itself. This
 * file only owns the click.
 *
 * Personalized products never get a quick-add button (their card links to the
 * product page instead) — a personalized line without a session is an order
 * nobody can fulfil.
 *
 * Dawn's globals (fetchConfig, routes, publish, PUB_SUB_EVENTS) are top-level
 * bindings of classic scripts, NOT window properties — test them with typeof.
 */

(function () {
  'use strict';

  // The cart drawer (rendered on every page) and the cart page section both
  // include this file, so on /cart the browser evaluates it twice. Without a
  // guard the second pass binds a second click handler and one tap on Add
  // sends two add-to-cart requests.
  if (window.pzCartUpsellReady) return;
  window.pzCartUpsellReady = true;

  function cartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  // Dawn's cart page owns its own line list and footer, and its CartItems only
  // re-renders after quantity changes it made itself. After an add there, a
  // reload is the simplest correct thing.
  function onCartPage() {
    return !!document.querySelector('cart-items');
  }

  function errorsElementFor(button) {
    return button.closest('cart-drawer')
      ? document.getElementById('CartDrawer-CartErrors')
      : document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
  }

  function onClick(event) {
    const button = event.target.closest('[data-pz-quick-add]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();

    const id = button.dataset.pzQuickAdd;
    const cart = onCartPage() ? null : cartElement();
    const config = fetchConfig('javascript');
    const body = { items: [{ id, quantity: 1 }] };
    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }
    config.body = JSON.stringify(body);

    const errors = errorsElementFor(button);
    if (errors) errors.textContent = '';
    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          throw new Error(response.description || response.message || 'cart error');
        }
        if (!cart) {
          window.location.reload();
          return;
        }
        cart.classList.remove('is-empty');
        // A multi-item add answers `{ items: [...] }` with no top-level key or
        // id; cart-notification needs the line key to find its product section.
        const last = Array.isArray(response.items) ? response.items[response.items.length - 1] : null;
        cart.renderContents(last && !response.key ? { ...last, ...response } : response);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pz-cart-upsell', cartData: response });
        }
      })
      .catch((error) => {
        console.warn('[pz-cart-upsell]', error);
        if (errors) errors.textContent = error.message || window.cartStrings?.error || '';
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('click', onClick);
})();
